export default "__VITE_ASSET__DOBIF9ng__"